// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
define(['react', '/util/date.js', 'lodash4',
    '/www/lum/pub/comp/label.js', 'react-input-mask', '/util/string.js',
    '/util/util.js', 'classnames', 'react-day-picker',
    '/www/lum/pub/util/general.js', '/www/locale/pub/i18n_react.js',
    '/www/lum/pub/comp/zbtn.js', '/www/lum/pub/comp/ga.js',
    '/www/util/pub/react_hooks.js', '/www/lum/pub/comp/form.js',
    '/www/lum/pub/comp/container.js', 'uikit',
    // Import only
    'css!/www/lum/pub/css/datetime.css', 'css!/react-day-picker'],
    (React, zdate, _, {Label}, Input_mask, string, zutil,
    classnames, Day_picker, general_util, {T}, {Zbtn}, ga,
    react_hooks, {Input}, {Container}, uikit)=>
{
const {withPopover, Menu, Tooltip, Input: {Checkbox}, ClickableTag,
    Layout: {Flex}} = uikit;
const {qw} = string;
const {ms} = zdate;
const {assign} = Object;
const {use_state, use_ref, use_context, use_cb, use_memo} = react_hooks;
const E = {};

const parse_time_state = (time, am_pm)=>{
    let d = zdate(time), hour_ms = d - zdate.align(d, 'DAY');
    let hours = Math.floor(hour_ms/ms.HOUR);
    hour_ms -= hours*ms.HOUR;
    const minutes = Math.floor(hour_ms/ms.MIN);
    if (am_pm!==null)
    {
        if (hours>=12)
        {
            hours -= 12;
            am_pm = 'pm';
        }
        else
            am_pm = 'am';
    }
    time = String(hours).padStart(2, '0');
    time += ':' + String(minutes).padStart(2, '0');
    return {time, am_pm};
};

class Time_picker extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = parse_time_state(props.value, props.am_pm);
        _.bindAll(this,
            qw`fix_time_value switch_format on_blur trigger_change`);
    }
    componentDidMount(){ this.trigger_change(); }
    componentDidUpdate(prev_props, prev_state){
        if (prev_props.am_pm!=this.props.am_pm)
            return this.update_am_pm(this.props.am_pm);
        if (zutil.equal_deep(this.state, prev_state))
            return;
        this.trigger_change();
    }
    trigger_change(){
        const {time, am_pm} = this.state;
        const {on_change, no_am_pm} = this.props;
        const m = time.match(/(\d\d):(\d\d)/);
        if (!m)
            return on_change({hours: null, minutes: null, ms: null});
        let hours = +m[1], minutes = +m[2];
        if (!no_am_pm && (am_pm=='pm'&&hours!=12 || am_pm=='am'&&hours==12))
            hours += 12;
        on_change({hours, minutes, ms: hours*ms.HOUR+minutes*ms.MIN});
    }
    fix_time_value(new_state, old_state){
        let {value, selection} = new_state;
        if (!selection || !old_state.selection ||
            selection.start<=old_state.selection.start)
        {
            return {value, selection};
        }
        const idx = selection.start==3 ? 1 : selection.start-1;
        const n = +value[idx];
        const {am_pm} = this.state;
        let start;
        switch (selection.start)
        {
        case 1:
            if (!am_pm && n>2 || am_pm && n>1)
            {
                value = `0${n}:${value.slice(3)}`;
                selection.start = 3;
                selection.end = 3;
            }
            break;
        case 3:
            start = +value[0];
            if (!Number.isFinite(start))
            {
                value = `0${n}${value.slice(3)}`;
                selection.start = 3;
                selection.end = 3;
            }
            if (!am_pm && start==2 && n>3 || am_pm && start==1 && n>2)
            {
                value = `${start}_${value.slice(3)}`;
                selection.start = 1;
                selection.end = 1;
            }
            break;
        case 4:
            if (n>5)
            {
                value = `${value.slice(0, 3)}__`;
                selection.start = 3;
                selection.end = 3;
            }
            break;
        }
        return {value, selection};
    }
    update_am_pm(new_am_pm){
        const {time, am_pm} = this.state;
        const upd = {am_pm: new_am_pm};
        let hours = +time.slice(0, 2);
        if (Number.isFinite(hours))
        {
            if (new_am_pm=='am' && hours>=12)
                hours -= 12;
            if (!new_am_pm && am_pm=='pm')
                hours += 12;
            upd.time = `${String(hours).padStart(2, '0')}${time.slice(2)}`;
        }
        this.setState(upd, this.trigger_change);
    }
    switch_format(checked){
        const new_am_pm = checked ? null: 'am';
        this.update_am_pm(new_am_pm);
        (this.props.on_format_switch||_.noop)(new_am_pm);
    }
    on_blur(){
        const {time} = this.state;
        if (/^\d\d:/.test(time) && time.includes('_'))
            this.setState({time: time.replace(/_/g, '0')});
    }
    render(){
        const {time, am_pm} = this.state;
        const {label, error, no_switch, disabled, no_am_pm,
            on_click} = this.props;
        const merediems = [{val: 'am', title: 'AM'}, {val: 'pm', title: 'PM'}];
        return <div className="time_picker" onClick={on_click}>
          <Label text={label}/>
          <div className="input_wrapper">
            <Input_mask mask="99:99" value={time} disabled={disabled}
              beforeMaskedValueChange={this.fix_time_value}
              onChange={ev=>this.setState({time: ev.target.value})}>
              {props=><div>
                <Input error={error} onBlur={this.on_blur} {...props}
                  disabled={disabled}/>
              </div>}
            </Input_mask>
            {!no_am_pm && <div className="time_picker_am_pm">
              {merediems.map(({val, title})=><button key={val}
                className={classnames({active: am_pm==val})}
                onClick={()=>this.setState({am_pm: val})}
                disabled={disabled||am_pm==null}>
                  {title}
                </button>)}
            </div>}
            {!no_switch && <Checkbox className="zcheckbox"
              label="24-hour format" checked={am_pm==null} disabled={disabled}
              onChange={this.switch_format}
            />}
          </div>
      </div>;
    }
}

// XXX william: this transformation should be internal to Date_picker_comp.
const transform_utc12 = (dir, v)=>{
    if (!v)
        return v;
    try {
        v = zdate(v);
    } catch(e){
        return;
    }
    // HACK: we want a pure utc day picker that doesn't care about time
    // to work around display glitches we make date picker work with UTC+12
    // and we convert back when a value is selected
    if (dir=='out')
    {
        return new Date(Date.UTC(v.getUTCFullYear(), v.getUTCMonth(),
            v.getUTCDate(), 0, 0, 0, 0));
    }
    return new Date(Date.UTC(v.getUTCFullYear(), v.getUTCMonth(),
        v.getUTCDate(), 12, 0, 0, 0));
};

const get_year_options = (start_year, on_click)=>{
    const curr_year = new Date().getFullYear();
    let years = [];
    while (start_year<=curr_year)
        years.push(start_year++);
    return years.map(y=>({key: y, text: y, onClick: ()=>on_click(y)}));
};

// prop date is from CaptionProps
const Caption = withPopover(
    ({date, popover})=>{
        const on_click = evt=>{
            evt.preventDefault();
            evt.stopPropagation();
            popover.toggle();
        };
        return <div role="heading" onClick={on_click}>
          {zdate.strftime('%B', date)+' '+date.getFullYear()}
        </div>;
    },
    ({start_year, on_year_click, date})=>{
        const on_click = use_cb(year=>
            on_year_click(new Date(year, date.getMonth())),
            [on_year_click, date]);
        const options = use_memo(()=>get_year_options(start_year, on_click),
            [start_year, on_click]);
        return <Menu items={options}/>;
    },
    {
        placement: 'bottom',
        wrapperClassName: 'DayPicker-Caption',
        wrapperStyle: {width: 'unset', cursor: 'pointer'},
    },
);

const Caption_wrapper = React.memo(props=>{
    return <Caption {...props} popoverProps={props}/>;
});
Caption_wrapper.displayName = 'Caption_wrapper';

// prop select_start_year - enables Select under year
const Date_picker_comp = props=>{
    const {show_specific, from, to, on_open_picker, on_close_picker,
        specific_options, select_start_year} = props;
    const transform_in = v=>transform_utc12('in', v);
    const transform_out = v=>transform_utc12('out', v);
    const today = zdate.align(zdate(), 'DAY');
    const yesterday = zdate.add(today, {day: -1});
    const default_options = [
        {label: 'Today', from: today, to: today, id: 'today'},
        {label: 'Yesterday', from: yesterday, to: yesterday,
            id: 'yesterday'},
        {label: 'Last week', from: zdate.add(today, {day: -7}),
            to: today, id: 'last_7_days'},
        {label: 'Last month', from: zdate.add(today, {day: -30}),
            to: today, id: 'last_30_days'},
    ];
    const specific_opts = (specific_options||default_options)
        .map(o=>assign({value: o.label.replace(/\s/g, '_').toLowerCase()}, o));
    const specific_ref = use_ref();
    const day_picker_ref = use_ref();
    const dialog_footer_ref = use_ref();
    const [click_cnt, set_click_cnt] = use_state(0);
    const [opened, set_opened] = use_state(false);
    // XXX william: close_listener is not being cleaned up correctly. If this
    // component unmounts before close_listener is triggered, then there will
    // be a dangling eventListener. This should be put into a use_effect hook.
    const ga_context = use_context(ga.Ga_context);
    const close_listener = use_ref();
    const open_picker = ()=>{
        if (close_listener.current)
            return;
        set_click_cnt(0);
        set_opened(true);
        (on_open_picker||_.noop)();
        ga.trigger('date_picker_open', ga_context, props);
        close_listener.current = e=>{
            if (day_picker_ref.current?.dayPicker?.contains(e.target) ||
                show_specific&&specific_ref.current?.contains(e.target) ||
                dialog_footer&&dialog_footer_ref.current?.contains(e.target))
            {
                return;
            }
            close_picker();
        };
        document.addEventListener('mousedown', close_listener.current);
    };
    const close_picker = ()=>{
        set_opened(false);
        (on_close_picker||_.noop)();
        document.removeEventListener('mousedown', close_listener.current);
        close_listener.current = null;
    };
    const on_change = ga.hook_fn(props.on_change, 'date_picker_change', props);
    const on_change_specific = ga.hook_fn(id=>{
        const opt = specific_opts.find(o=>o.id==id);
        on_change({from: transform_out(opt.from),
            to: transform_out(opt.to)}, props.id);
    }, 'date_picker_range_change', props);
    const on_day_click = (day, opt = {})=>{
        if (opt.disabled)
            return;
        day = zdate.align(day, 'DAY');
        let new_val;
        if (!props.pick_range)
            new_val = transform_out(day);
        else if (click_cnt%2==0 || +from==+to && +day==+from)
            new_val = {from: transform_out(day), to: transform_out(day)};
        else
        {
            const tmp = Day_picker.DateUtils.addDayToRange(day, {from, to});
            new_val = {from: transform_out(zdate.align(tmp.from, 'DAY')),
                to: transform_out(zdate.align(tmp.to, 'DAY'))};
        }
        set_click_cnt(click_cnt+1);
        on_change(new_val, props.id);
        if (props.pick_range)
            props.on_range_change?.(new_val, props.id);
        if (!props.keep_open && !(props.pick_range && !click_cnt))
            close_picker();
    };
    const handle_key_pressed = use_cb(e=>{
        if (e.key=='Enter')
            open_picker();
    }, []);
    const {label, date_text, disabled_days, placeholder, icon_placement,
        error, disabled, style = {}, tooltip, tooltip_placement, classes,
        classname, months_qtt, render_day, selected_days, tooltip_props,
        dialog_footer, modifiers, from_month, to_month,
        dialog_align} = props;
    const [month, set_month] = use_state(transform_in(props.initial_month ||
        from));
    const initial_month = transform_in(props.initial_month || from);
    const {width, ...wrapper_style} = style;
    const input_style = width && {width} || {};
    const dialog_classname = classnames(classname+'_dialog',
        dialog_align && `align_${dialog_align}`);
    return <div className={classnames(classname, classes,
      opened && classname+'_opened')} style={wrapper_style}>
      <Input id={props.id} label={label} value={date_text} error={error}
        read_only icon="calendar" icon_size="tiny" on_click={open_picker}
        disabled={disabled} style={input_style} tooltip={tooltip}
        placeholder={placeholder} tooltip_placement={tooltip_placement}
        tooltip_props={tooltip_props} on_key_down={handle_key_pressed}
        onMouseEnter={ga.hook_fn('date_picker_hover', props)}
        icon_placement={icon_placement}/>
      {opened && <div className={dialog_classname}>
        <Container elevated>
          <Day_picker numberOfMonths={months_qtt||1}
            onDayClick={on_day_click} fixedWeeks
            selectedDays={selected_days}
            disabledDays={disabled_days}
            renderDay={render_day}
            initialMonth={initial_month} modifiers={modifiers}
            fromMonth={from_month} toMonth={to_month}
            month={month} captionElement={select_start_year&&<Caption_wrapper
                start_year={select_start_year} on_year_click={set_month}/>}
            ref={day_picker_ref}/>
          {!!show_specific &&
            <div ref={specific_ref}
              onMouseOver={ga.hook_fn('date_picker_range_hover', props)}
              onClick={ga.hook_fn('date_picker_range_click', props)}
              className={classname+'_specific'}>
              <Flex gap="04">
                {specific_opts.map(o=><ClickableTag
                  key={o.value} text={o.label} size="md"
                  onClick={()=>on_change_specific(o.id)}
                />)}
              </Flex>
            </div>
          }
          {!!dialog_footer &&
              <div className={classname+'_dialog_footer'}
                ref={dialog_footer_ref}>
                {dialog_footer}
              </div>
          }
        </Container>
      </div>}
    </div>;
};

const Date_picker = props=>{
    const {value} = props;
    // XXX william: this transformation to get the date to display correctly
    // should be internal to Date_picker_comp and shouldn't be relevant
    // here.
    const transformed = transform_utc12('in', value);
    const date_text = value && !transformed ? JSON.stringify(value) :
        transformed ? zdate.strftime('%d/%m/%Y', transformed) : '';
    // Day_picker crashes if null value is used - pass undefined instead
    const selected_days = transformed || undefined;
    const render_day = day=>{
        return <div className="date_picker_day">
          {day.getDate()}
        </div>;
    };
    return <Date_picker_comp
      {...props}
      classname='cp_date_picker'
      date_text={date_text}
      selected_days={selected_days}
      render_day={render_day}/>;
};

const Date_range_picker = p=>{
    const make_inclusive = ({to, on_change, on_range_change,
        inclusive, ...rest})=>{
        // add day on out
        let add_day = ({from, to: t})=>({from, to: zdate.add(t, {d: 1})});
        let i_on_change = v=>on_change(add_day(v));
        let i_on_range_change = v=>on_range_change(add_day(v));
        // subtract day on in
        let i_to = to;
        if (to && +to!=+rest.from)
            i_to = zdate.add(to, {d: -1});
        return assign(rest,
            on_change && {on_change: i_on_change},
            on_range_change && {on_range_change: i_on_range_change},
            to && {to: i_to},
        );
    };
    let props = p.inclusive ? make_inclusive(p) : p;
    // XXX william: this transformation to get the date to display
    // correctly should be internal to Date_picker_comp and shouldn't be
    // relevant here.
    const {from, to} = props;
    const transform_in = v=>transform_utc12('in', v);
    const get_day_tooltip = (day, modifiers)=>{
        const {disabled_tooltip, tooltips = []} = props;
        if (modifiers.disabled && disabled_tooltip)
            return disabled_tooltip;
        const tooltip = tooltips.filter(t=>t.after && day>t.after ||
            t.before && day<t.before)[0] || {};
        return tooltip.text;
    };
    const render_day = (day, modifiers)=>{
        const {disabled, outside} = modifiers;
        const fmt_date = d=>zdate.strftime('%Y/%m/%d', d);
        const highlight = !disabled && !outside && _.some(qw`value from to`,
            v=>props[v] && fmt_date(props[v])==fmt_date(day));
        const classname = general_util.get_classname('date_picker_day',
            '', 'highlight', {highlight});
        return <Tooltip tooltip={get_day_tooltip(day, modifiers)} noWrap>
          <div className={classname}>{day.getDate()}</div>
        </Tooltip>;
    };
    const fmt_date = d=>d ? zdate.strftime('%d/%m/%Y', d) : '';
    const date_text = from || to ? `${fmt_date(from)} – ${fmt_date(to)}` : '';
    const selected_days = [transform_in(from), {
        from: transform_in(from),
        to: transform_in(to)}];
    return <Date_picker_comp
      {...props}
      pick_range
      classname='date_range_picker'
      months_qtt={2}
      render_day={render_day}
      date_text={date_text}
      selected_days={selected_days}/>;
};

class Date_time_picker extends React.PureComponent {
    constructor(props){
        super(props);
        const d = zdate(props.value);
        const date = zdate.align(d, 'DAY');
        this.state = {date, time: d-date};
    }
    componentDidUpdate(prev_props, prev_state){
        if (zutil.equal_deep(this.state, prev_state))
            return;
        const {date, time} = this.state;
        const {on_change} = this.props;
        if (time==null)
            return on_change(null);
        on_change(zdate(+date+time));
    }
    click_trap(e){
        e.stopPropagation();
        e.preventDefault();
    }
    render(){
        const {date, time} = this.state;
        const {disabled, time_props, date_props} = this.props;
        return <div className="datetime_wrapper">
          <Date_picker label={date_props&&date_props.label||'Date'}
            value={date} error={this.props.error} disabled={disabled}
            {...date_props} on_change={v=>this.setState({date: v})}/>
          <Time_picker label={time_props&&time_props.label||'Time'}
            value={time} error={this.props.error}
            disabled={disabled} {...time_props} on_click={this.click_trap}
            on_change={opt=>this.setState({time: opt.ms})}/>
        </div>;
    }
}

class Time_range_picker extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = {from: props.from, to: props.to, am_pm: 'am'};
    }
    componentDidUpdate(prev_props, prev_state){
        const {from, to} = this.state;
        if (from==prev_state.from && to==prev_state.to)
            return;
        if (Number.isFinite(from) && Number.isFinite(to) && from<=to)
            this.props.on_change({from, to});
        else
            this.props.on_change(null);
    }
    render(){
        const {from, to, am_pm} = this.state;
        return <div className="time_range_picker">
          <div className="time_range_pickers_wrapper">
            <Time_picker label="From" value={from} error={this.props.error}
              on_change={opt=>this.setState({from: opt.ms})} no_switch
              am_pm={am_pm}/>
            <Time_picker label="Until" value={to} error={this.props.error}
              on_change={opt=>this.setState({to: opt.ms})} am_pm={am_pm}
              on_format_switch={v=>this.setState({am_pm: v})}/>
          </div>
          {Number.isFinite(from) && Number.isFinite(to) && from>to &&
              !this.props.allow_reverse &&
              <Label text="Invalid time range" error/>}
        </div>;
    }
}

const week_days_options = [
    {label: 'Mon', value: 'mon', name: 'Monday'},
    {label: 'Tue', value: 'tue', name: 'Tuesday'},
    {label: 'Wed', value: 'wed', name: 'Wednesday'},
    {label: 'Thu', value: 'thu', name: 'Thursday'},
    {label: 'Fri', value: 'fri', name: 'Friday'},
    {label: 'Sat', value: 'sat', name: 'Saturday'},
    {label: 'Sun', value: 'sun', name: 'Sunday'},
];
const workdays = ['mon', 'tue', 'wed', 'thu', 'fri'];
class Week_day_picker extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = week_days_options.reduce((s, opt)=>{
            s[opt.value] = zutil.get(props.days, opt.value, false);
            return s;
        }, {});
        _.bindAll(this, qw`set_workdays_only`);
    }
    componentDidUpdate(prev_props, prev_state){
        if (!zutil.equal_deep(this.state, prev_state))
            this.props.on_change(assign({}, this.state));
    }
    is_workdays_only(){
        return Object.keys(this.state).every(
            k=>workdays.includes(k) ? this.state[k] : !this.state[k]);
    }
    set_workdays_only(checked){
        const upd = Object.keys(this.state).reduce((u, k)=>{
            if (checked)
                u[k] = workdays.includes(k);
            else if (!workdays.includes(k))
                u[k] = true;
            return u;
        }, {});
        this.setState(upd);
    }
    toggle_day_value(key){
        if (!this.props.no_empty || !this.state[key]
            || Object.keys(this.state).filter(k=>this.state[k]).length > 1)
        {
            this.setState({[key]: !this.state[key]});
        }
    }
    render_new(){
        const {show_workdays} = this.props;
        return <div className="week_day_picker--new">
          <div className="week_days_container--new">
            {week_days_options.map(o=>{
                const cls = classnames('week_day_option--new',
                {'week_day_option--selected': this.state[o.value]});
                return <div key={o.value} className={cls}
                    onClick={()=>this.toggle_day_value(o.value)}>
                    <T>{o.label}</T>
                </div>;
            })}
          </div>
          {show_workdays && <Checkbox label="Workdays only"
            ignoreOldCheckbox={true}
            classes="week_day_workdays_only--new"
            checked={this.is_workdays_only()}
            tooltip={this.props.workdays_tooltip}
            on_change={this.set_workdays_only}/>}
        </div>;
    }
    render(){
        const {show_workdays, render_new} = this.props;
        if (render_new)
            return this.render_new();
        const is_every_day = week_days_options.every(o=>this.state[o.value]);
        return <div className="week_day_picker">
          <div className="week_day_labels">
            {is_every_day
                ? <T>Every day</T>
                : week_days_options.filter(o=>this.state[o.value])
                    .map(o=>o.name).join(', ')}
          </div>
          <div>
            {week_days_options.map(o=><Zbtn key={o.value}
              classes={classnames('week_day_option',
                  {week_day_disabled: !this.state[o.value]})} no_pulse
              onClick={()=>this.toggle_day_value(o.value)}>
              <T>{o.label}</T>
            </Zbtn>)}
          </div>
          {show_workdays && <Checkbox label="Workdays only"
            ignoreOldCheckbox={true}
            classes="week_day_workdays_only"
            checked={this.is_workdays_only()}
            tooltip={this.props.workdays_tooltip}
            on_change={this.set_workdays_only}/>}
        </div>;
    }
}

assign(E, {Time_picker, Date_picker, Date_range_picker, Date_time_picker,
    Time_range_picker, Week_day_picker});

return E; }); // eslint-disable-line
